import React, { Fragment } from 'react';
import Popup from 'reactjs-popup';
import OrderFormRoot, { OrderFormProps, ConfType, ConfOption, ConfPricing, ConfTierPrice } from './OrderFormRoot';
import { OrderFormState } from './OrderFormRoot';
import DateTimePicker from 'react-datetime-picker';
import usstates from '../util/us-states';
import { RadioButtonGroup } from '../components/radio-button-group';
import { effectiveWeight } from '../util/effective-weight'
import { AcquireDataType, ReleaseDataType } from '../types/order';
import Modal from '../components/modal'
import classNames from 'classnames';
import { OrderDataItemPriceData } from '../classes/order';

export interface OrderProps extends OrderFormProps, OrderFormState {

  updateField: (e:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => boolean;
  updateFieldWeight: (e:React.ChangeEvent<HTMLInputElement>) => boolean;
  update: (f:string, v:any) => boolean;

  /*
  createOrderRecord: OrderFormRoot["createOrderRecord"];

  setAcquireType: (type: AcquireDataType) => void;
  setReleaseType: (type: ReleaseDataType) => void;

  updateAcquireField: (e:React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | Date) => boolean;
  updateReleaseField: (e:React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | Date) => boolean;
  */
}


export interface OrderFState {
  formError: undefined | "weight" | "service";
  calendarOpen: string | undefined;
}


class OrderForm extends React.Component<OrderProps, OrderFState> {

  private area_refs: {
    keepsakes: React.RefObject<HTMLDivElement>;
    nameplate: React.RefObject<HTMLDivElement>;
    nameplate_lines: React.RefObject<HTMLDivElement>;
    pawprint: React.RefObject<HTMLDivElement>;
    addons: React.RefObject<HTMLDivElement>;
    acquire: React.RefObject<HTMLDivElement>;
    release: React.RefObject<HTMLDivElement>;
  };


  constructor(props: OrderProps) {
    super(props);

    this.state = {
      formError: undefined,
      calendarOpen: undefined,
    };

    this.area_refs = {
      keepsakes: React.createRef(),
      nameplate: React.createRef(),
      nameplate_lines: React.createRef(),
      pawprint: React.createRef(),
      addons: React.createRef(),
      acquire: React.createRef(),
      release: React.createRef(),
    }
  }


  componentDidUpdate(prevProps: OrderProps) {
    if (this.props.service !== prevProps.service || this.props.weight !== prevProps.weight) {

      const keepsake_services = ['private', 'noservice'];
      if (this.props.service && keepsake_services.includes(this.props.service.tag) && (this.props.weight as number) > 0) {
        this.areaExpand(this.area_refs.keepsakes);
      } else {
        this.areaContract(this.area_refs.keepsakes);
      }

      if (this.props.service && (this.props.weight as number) > 0) {
        this.areaExpand(this.area_refs.pawprint);
        this.areaExpand(this.area_refs.acquire);
        this.areaExpand(this.area_refs.release);
        if (!['noservice'].includes(this.props.service.tag)) {
          this.areaExpand(this.area_refs.addons);
        } else {
          this.areaContract(this.area_refs.addons);
        }
      } else {
        this.areaContract(this.area_refs.pawprint);
        this.areaContract(this.area_refs.addons);
        this.areaContract(this.area_refs.acquire);
        this.areaContract(this.area_refs.release);
      }        

    }

    if (this.props.extras_urn !== prevProps.extras_urn || this.props.weight !== prevProps.weight || this.props.service !== prevProps.service) {
      const extras_urn = this.props.extras_urn;
      if (
          (
            this.props.service && this.props.service.tag === "noservice" 
          )
          ||
          ( 
            extras_urn && (this.props.weight as number) > 0 && (
            extras_urn.tag === 'cedar_chest_urn' ||
            extras_urn.tag === 'cedar_tower_urn' ||
            extras_urn.tag === 'photo_frame_urn')
          )
        ) {
        this.areaExpand(this.area_refs.nameplate);
      } else {
        this.areaContract(this.area_refs.nameplate);
      }
    }

    if (this.props.extras_nameplate !== prevProps.extras_nameplate) {
      if (this.props.extras_nameplate) {
        this.areaExpand(this.area_refs.nameplate_lines);
      } else {
        this.areaContract(this.area_refs.nameplate_lines);
      }
    }


    if (this.props.service && this.props.service !== prevProps.service
        || this.props.extras_pawprint !== prevProps.extras_pawprint
      ) {
      // we have a service selected, and the service has changed
      if (this.props.service?.tag && ['burial', 'communal'].includes(this.props.service.tag)) {
        // these services get no release type, unless there is a pawprint
        if (!this.props.extras_pawprint) {
          this.update('release_type', "");
        } else {
          this.update('release_type', "home");
        }
      } else {
        // default to home delivery
        this.update('release_type', "home");
      }
    }

  }


  render() {

    const service = this.props.service;
    const extras_urn = this.props.extras_urn;

    const weight_vals = this.props.convertWeight(this.props.weight, true);

    return (
      <div className="PubOrderForm">
  
        <form onSubmit={this.checkForm}>
  
          <div className="container">

            <h1>Place an Order</h1>
            <p>
              Our sincerest condolences at this difficult time. Once this aftercare form is filled out, you will receive a follow up email with confirmation details along with the invoice (to be paid before or at the time of visit). 
              We are by confirmed appointment only. 
              If we are available for your request, you will have a confirmation email within one (1) hour. 
              If you have not received our confirmation email within one (1) hour we do suggest that you contact a twenty four hour emergency hospital. 
              Having this form filled out does secure a priority position in our queue for the next available appointment.
            </p>
            <p>
              Our Condolences,<br />
              Precious Pets Memorial Service 
            </p>

            <h4>Pet Information</h4>

            <div className="form-group">
              <label>Pet's Name</label>
              <input type="text" className="form-control" name="pet_name" required 
                value={this.props.pet_name}
                onChange={this.updateField} />
            </div>
    
            <div className="form-group" style={{maxWidth: '500px'}}>
              <label>Species</label>
              <input type="text" className="form-control" name="pet_species" required 
                list="PetSpeciesAutocomplete" 
                value={this.props.pet_species} 
                onChange={this.updateField} />

              <datalist id="PetSpeciesAutocomplete">
                <option value="Dog" />
                <option value="Cat" />
                <option value="Hamster" />
                <option value="Rabbit" />
                <option value="Bird" />
                <option value="Iguana" />
                <option value="Lizard" />
                <option value="Snake" />
                <option value="Fish" />
                <option value="Ferret" />
                <option value="Frog" />
                <option value="Gecko" />
              </datalist>
            </div>

            <div className="form-group" style={{maxWidth: '500px'}}>
              <label>Weight</label>

              <div className="weightField">
                <div className="c">
                  <label>lbs</label>
                  <input type="number" className="form-control" name="weight_lbs" 
                    id="OrderFormWeightLbs"
                    min="0" max={this.props.max_weight} step="1"
                    value={weight_vals[0]} 
                    onChange={this.updateFieldWeight} />
                </div>
                <div className="c">
                  <label>oz</label>
                  <input type="number" className="form-control" name="weight_oz" 
                    id="OrderFormWeightOz"
                    min="0" max={15} step="1"
                    value={weight_vals[1]} 
                    onChange={this.updateFieldWeight} />
                </div>
              </div>
            </div>
    

            <h4>Owner Information</h4>

            <div className="form-group">
              <label>Owner Name</label>
              <input type="text" className="form-control" name="owner_name" 
                required autoComplete="name"
                value={this.props.owner_name} 
                onChange={this.updateField} />
            </div>
    
            <div className="row">

              <div className="col-lg-6">
                <div className="form-group" style={{maxWidth: '500px'}}>
                  <label>Phone Number</label>
                  <input type="tel" className="form-control" name="owner_phone" required
                    value={this.props.owner_phone} 
                    onChange={this.updateField} />
                </div>
              </div>
              
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" className="form-control" name="owner_email" 
                    required autoComplete="email"
                    value={this.props.owner_email} 
                    onChange={this.updateField} />
                </div>
              </div>

            </div>



            <div className="">
              
              <div className="form-group">
                <label>Address Line1</label>
                <input type="text" className="form-control" name="addr_address1"
                  value={this.props.addr_address1} onChange={this.updateField} 
                  maxLength={255} required autoComplete="address-line1" />
              </div>

              <div className="form-group">
                <label>Address Line2</label>
                <input type="text" className="form-control" name="addr_address2"
                  value={this.props.addr_address2} onChange={this.updateField} 
                  maxLength={255} autoComplete="address-line2" />
              </div>

              <div className="row" style={{display: "flex"}}>
                <div className="col-sm-12">
                  <div className="form-group">
                    <label>City</label>
                    <input type="text" className="form-control" name="addr_city"
                      value={this.props.addr_city} onChange={this.updateField} 
                      maxLength={255} required autoComplete="address-level2" />
                  </div>
                </div>

                <div className="col-sm-12">
                  <div className="form-group">
                    <label>State</label>
                    <select className="form-control" name="addr_state" 
                      value={this.props.addr_state || 'CA'}
                      onChange={this.updateField} required autoComplete="address-level1">
                      {[...usstates].map(ss => (
                      <option key={ss[0]} value={ss[0]}>{ss[1]}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-sm-12">
                  <div className="form-group">
                    <label>Zip</label>
                    <input type="text" className="form-control" name="addr_zip"
                      value={this.props.addr_zip} onChange={this.updateField} 
                      maxLength={255} required autoComplete="postal-code" />
                  </div>
                </div>
              </div>

            </div>


          </div>


          <div className="container">

            <div className={'form-area' + (((this.props.weight as number) > 0) ? ' active' : '')}>
              <h4>Choose Service:</h4>
              {this.showMainChoices}
            </div>

          </div>


          <div className="container">

            <div className={'form-area hideaway'}
                ref={this.area_refs.keepsakes}>
              <div className="form-area-content">
                <h4>Keepsake Urns (optional)</h4>
                {this.showOptions('extras_urn', this.props.urns)}
              </div>
            </div>


            <div className={'form-area hideaway'}
              ref={this.area_refs.nameplate}>
              <div className="form-area-content">
                <h5>Nameplate (optional)</h5>
                {this.showNamePlate}
              </div>
            </div>

          </div>


          <div className="container">

            <div className={'form-area hideaway'}
              ref={this.area_refs.pawprint}>
              <div className="form-area-content">
                <h5>Clay Paw Print (optional)</h5>
                {this.showPawPrint}
              </div>
            </div>

          </div>


          <div className="container">
            <div className={'form-area hideaway'}
              ref={this.area_refs.addons}>
              <div className="form-area-content">
                <h5>Additional Services (optional)</h5>
                {this.showAddServices}
              </div>
            </div>

          </div>



          <div className={classNames("container area-acquire", { 'calendar-active': this.state.calendarOpen === 'acquire' })}>
            <div className={'form-area hideaway'} ref={this.area_refs.acquire}>
            <div className="form-area-content">
                <h5>Appointment Option</h5>

                {this.props.service?.tag && ['noservice'].includes(this.props.service.tag)
                ? (
                  <div>
                    No acquire option available with this service type
                  </div>
                ) : (

                <Fragment>
                  <RadioButtonGroup
                    name="acquire"
                    value={this.props.acquire_type}
                    label="Appointment Option"
                    options={[
                      { label: "Pickup", value: "home" },
                      { label: "Drop-off", value: "dropoff" },
                    ]}
                    onChange={(e) => this.update('acquire_type', e.detail)}
                    ></RadioButtonGroup>

                  {this.showAcquireForm}
                </Fragment>

                )}
              </div>
            </div>
          </div>


          <div className={classNames("container area-release margin-top2", { 'calendar-active': this.state.calendarOpen === 'release' })}>
            <div className={'form-area hideaway'}  ref={this.area_refs.release}>
              <div className="form-area-content">
                <h5>Return Option</h5>

                {this.props.service?.tag && ['burial', 'communal'].includes(this.props.service.tag)
                  && !this.props.extras_pawprint
                ? (
                  <div>
                    No return option available with this service type
                  </div>
                ) : (

                  <Fragment>
                  <RadioButtonGroup
                    name="release"
                    value={this.props.release_type}
                    label="Return Option"
                    options={[
                      { label: "Home Delivery", value: "home" },
                      { label: "PPMS Office Pick-up", value: "pickup" },
                    ]}
                    onChange={(e) => this.update('release_type', e.detail)}
                    ></RadioButtonGroup>

                  {this.showReleaseForm}
                  </Fragment>

                )}
              </div>
            </div>
          </div>


          <div className="container">

            <div className="form-area active" style={{marginTop: '2rem'}}>
              <label>Other/Request</label>
              <textarea name="comments" className="form-control" 
                rows={5} maxLength={5000}
                value={this.props.comments}
                onChange={this.updateField}></textarea>
            </div>


            <div className="form-group text-center">
              <button type="submit" className="btn btn-primary btn-lg">
                Review Order
              </button>
            </div>

          </div>
  
        </form>
  

        <Modal active={!!this.state.formError}>

          <p className="lead">
            {this.state.formError === "weight" ? (

              <span>Please enter your pet's weight in the weight field and select a service to proceed.</span>

            ) : (

              <span>Please select a service to proceed.</span>

            )}
          </p>

        </Modal>

      </div>
    );
  
  }


  get showMainChoices() {
    const sret = [];

    let i = 0;
    for (let stype of this.props.types) {

      let service = this.props.service;
      let exclass = service && service.tag === stype.tag ? ' selected' : ''

      if (stype.tag === 'service_plan') {
        if (this.props.user && !this.props.user.data.has_service_plan) {
          // don't allow the service plan option unless the user is marked as a service plan
          continue;
        }
      }

      sret.push(
        <div className="fcol main-service-col" key={stype.label}>
          <div className={'main-service'+exclass} 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              const isInfoClick = (e.nativeEvent.target as HTMLAnchorElement).classList.contains('infopop') 
              if (isInfoClick) {
                return false;
              }

              return this.update('service', stype);
            }}>

            <div className="sel">
              <div className="radio">
                <label className="form-check-label" htmlFor={'CremationType_'+stype.tag}>
                  <input type="radio" 
                    id={'CremationType_'+stype.tag} 
                    name="service" 
                    className="form-check-input" 
                    value={stype.tag}
                    checked={!!(service && service.tag === stype.tag)} 
                    onChange={(e: React.FormEvent) => { e.preventDefault(); this.update('service', stype); }}
                    style={{ pointerEvents: 'none' }}
                    />
                  {" "}
                  {stype.label}
                </label>

                <Popup trigger={<a tabIndex={0} className="infopop">i</a>} 
                  position={['top center']} 
                  keepTooltipInside={true}>
                  <div>
                    <h3>{stype.label}</h3>
                    <p>{stype.tooltip}</p>
                  </div>
                </Popup>

              </div>
            </div>

            <div className="cont">
              {stype.tag === 'noservice' && (
                <p>
                  {stype.description}
                </p>
              )}
              {(this.props.weight as number) > 0 ? this.showPricing(stype) : (
                <p><i>Please enter your pet's weight for pricing</i></p>
              )}
            </div>

          </div>
        </div>
      );
    }


    const ret = (
      <div className="frow">
        {sret}
      </div>
    )

    return ret;
  }


  showOptions(opttag:string, opts:ConfOption[]) {
    const cols = [];

    for (let opt of opts) {

      let service = (this.props as any)[opttag];
      let exclass = service && service.tag === opt.tag ? ' selected' : '';

      cols.push(
        <div className="fcol option-col" key={opttag+'_'+opt.tag}>
          <div className={'option'+exclass} 
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              return this.update(opttag, opt);
            }}>

            <div className="sel">
              <div className="radio">
                <label className="form-check-label" htmlFor={'option_'+opttag+'_'+opt.tag}>
                  <input type="radio" 
                    id={'option_'+opttag+'_'+opt.tag} 
                    name="option" 
                    value={opt.tag} 
                    checked={!!((this.props as any)[opttag] === opt)} 
                    onChange={(e) => {e.preventDefault(); this.update(opttag, opt)}} />
                  {" "}
                  {opt.label}
                </label>
              </div>
            </div>

            <div className="cont">

              {this.showPricing(opt)}

              {opt.engraving_price !== undefined ? (
            
                <div className={((this.props as any)[opttag]?.tag === opt.tag) ? 'form-group' : 'form-group hidden'}>
                  <label>
                    Generic Laser Engraving 
                    +{this.toMoney(opt.engraving_price)}
                  </label>
                  <select className="form-control" value={this.props.extras_urn_detail} onChange={this.changeUrnType}>
                    <option value="">None</option>
                    <option value="cat">Cat</option>
                    <option value="dog">Dog</option>
                    <option value="paw">Paw</option>
                  </select>
                </div>

              ) : ''}


              <div className={((this.props as any)[opttag]?.tag === opt.tag) ? '' : 'hidden'}>
                <button type="button" className="btn btn-remove btn-sm" 
                  onClick={(e) => this.clearOption(e, opttag)}>
                  remove
                </button>
              </div>

            </div>

          </div>
        </div>
      );
    }

    const ret = (
      <div className="frow">
        {cols}
      </div>
    )

    return ret;    
  }


  changeUrnType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    e.stopPropagation();
    this.update('extras_urn_detail', e.target.value)
  }


  get showNamePlate() {
    const nameplate = this.props.extras_nameplate;

    return (
      <div className="nameplate">
        <div>
          <div className="checkbox">
            <label>
              <input type="checkbox" name="nameplate" 
                checked={ !!(nameplate && nameplate.tag) } 
                onChange={(e) => this.update('extras_nameplate', e.target.checked ? this.props.nameplate : undefined)}
                />
              Custom Engraved Nameplate
              {this.showPrice(this.props.nameplate.pricing)}
            </label>
          </div>
          
        </div>

        <div className={'form-area hideaway'} ref={this.area_refs.nameplate_lines}>
          <div className="form-area-content">
            <div className="form-group">
              
              <label>
                (3 lines, up to 25 characters per line)
              </label>

              <input type="text" className="form-control"
                name="nameplate_line1" 
                maxLength={25}
                value={this.props.nameplate_line1} 
                onChange={this.updateField}
                autoComplete="off"
                />
            </div>
            <div className="form-group">
              <input type="text" className="form-control" 
                name="nameplate_line2" 
                maxLength={25}
                value={this.props.nameplate_line2} 
                onChange={this.updateField}
                autoComplete="off"
                />
            </div>
            <div >
              <input type="text" className="form-control"
                name="nameplate_line3" 
                maxLength={25}
                value={this.props.nameplate_line3} 
                onChange={this.updateField}
                autoComplete="off"
                />
            </div>
          </div>
        </div>
      </div>
    )
  }


  get showPawPrint() {
    const pawprint = this.props.extras_pawprint;

    return (
    <div className="pawprint">
      <div className="checkbox">
        <label>
          <input type="checkbox" name="pawprint" 
            checked={!!(pawprint && pawprint.tag)}
            onChange={(e) => this.update('extras_pawprint', e.target.checked ? this.props.pawprint : undefined)}
            />
          Clay Paw Print
          {this.showPrice(this.props.pawprint.pricing)}
        </label>
      </div>  

      <div className="form-inline" style={{ 'display': (this.props.extras_pawprint ? 'block' : 'none') }}>
        <div className="form-group">
          <label style={{marginRight: '1rem'}}>QTY:</label>
          <input type="number" className="form-control" name="extras_pawprint_qty"
            value={this.props.extras_pawprint_qty} 
            onChange={this.updateField} 
            min={1} max={99} step={1}
            required={!!this.props.extras_pawprint}
            style={{ width: '6rem' }} />
        </div>
      </div>
    </div>
    )
  }


  get showAddServices() {
    const addon_priority = this.props.extras_addon_priority;
    const addon_viewing = this.props.extras_addon_viewing;
    const addon_viewing_and_priority = this.props.extras_addon_viewing_and_priority;
    const addon_after_hours_appt = this.props.extras_addon_after_hours_appt;

    let has_viewing = !!(addon_viewing && addon_viewing.tag);
    let has_priority = !!(addon_priority && addon_priority.tag);
    const has_viewing_and_priority_bundle = (!!(addon_viewing_and_priority && addon_viewing_and_priority.tag)); // || (has_viewing && has_priority);

    if (has_viewing_and_priority_bundle) {
      //has_viewing = false;
      //has_priority = false;
    }

    return (
    <>
    <div className="row">
      <div className="col-sm-6 col-lg-4 addon_service" style={{ border: "1px solid rgba(0,0,0,0.1)", borderRadius: "0.5rem", paddingTop: "0.5em", paddingBottom: "0.5em" }}>
        <div className="checkbox">
          <label>
            <input type="checkbox" name="addon_viewing_and_priority" 
              checked={has_viewing_and_priority_bundle}
              onChange={(e) => {
                return this.update('extras_addon_viewing_and_priority', e.target.checked ? this.props.addon_viewing_and_priority : undefined)
              }}
              />
            Priority Service + Viewing Service Bundle
            {this.showPrice(this.props.addon_viewing_and_priority.pricing)}
          </label>
        </div>  
      </div>


      <div className={`col-sm-6 col-lg-4 addon_service ${has_viewing_and_priority_bundle ? 'hidden' : ''}`}>
        <div className="checkbox">
          <label>
            <input type="checkbox" name="addon_priority" 
              checked={has_priority}
              onChange={(e) => this.update('extras_addon_priority', e.target.checked ? this.props.addon_priority : undefined)}
              />
            Priority Service
            {this.showPrice(this.props.addon_priority.pricing)}
          </label>
        </div>  
      </div>

      <div className={`col-sm-6 col-lg-4 addon_service ${has_viewing_and_priority_bundle ? 'hidden' : ''}`}>
        <div className="checkbox">
          <label>
            <input type="checkbox" name="addon_viewing" 
              checked={has_viewing}
              onChange={(e) => this.update('extras_addon_viewing', e.target.checked ? this.props.addon_viewing : undefined)}
              />
            Viewing Service
            {this.showPrice(this.props.addon_viewing.pricing)}
          </label>
        </div>  
      </div>
    </div>

    <div className="row">
      <div className="col-sm-6 col-lg-3 addon_service">
        <div className="checkbox">
          <label>
            <input type="checkbox" name="addon_viewing" 
              checked={!!(addon_after_hours_appt && addon_after_hours_appt.tag)}
              onChange={(e) => this.update('extras_addon_after_hours_appt', e.target.checked ? this.props.addon_after_hours_appt : undefined)}
              />
            After Hours Appointment
            {this.showPrice(this.props.addon_after_hours_appt.pricing)}
          </label>
        </div>  
      </div>      
    </div>
    </>
    )
  }


  get showAcquireForm() {
    switch(this.props.acquire_type) {
      case "home":
        return this.showAcquireForm_home;
      case "dropoff":
        return this.showAcquireForm_dropoff;
    }
  }

  
  get showAcquireForm_home() {

    const hdd = this.props;
    const reqDate = hdd.acquire_time ? new Date(hdd.acquire_time) : null;
    
    const feePrice = new OrderDataItemPriceData(this.props.weight || 0, hdd.acquire_fees.find(f => f.type === 'home')?.pricing, this.props.service?.tag);

    return (
    <div className="dohomedelivery">

      <h5><small>Pickup</small></h5>
      <p>PPMS will pick up directly from the your residence, hospital or emergency scene.</p>

      {feePrice && feePrice.total ? 
      <h5>
        Pickup Fee: {this.toMoney(feePrice.total)}
      </h5>
      : ''}

      <div className="checkbox" style={{ 
        display: hdd.acquire_type === "home" ? 'block' : 'none',
        }}>
        <label>
          <input type="checkbox" name="acquire_use_main_address" value={1} 
            defaultChecked={this.props.acquire_use_main_address} 
            onChange={() => this.update('acquire_use_main_address', !hdd.acquire_use_main_address)}
            />
          Use main address above
        </label>
      </div>

      <div style={{ display: (this.props.acquire_use_main_address ? 'none' : 'block') }}>
        
        <div className="form-group">
          <label>Name</label>
          <input type="text" className="form-control" name="acquire_home_addr_name"
            value={hdd.acquire_home_addr_name} onChange={this.updateField} 
            maxLength={255} required={!this.props.acquire_use_main_address} />
        </div>

        <div className="form-group">
          <label>Address Line1</label>
          <input type="text" className="form-control" name="acquire_home_addr_address1"
            value={hdd.acquire_home_addr_address1} onChange={this.updateField} 
            maxLength={255} required={!this.props.acquire_use_main_address} />
        </div>

        <div className="form-group">
          <label>Address Line2</label>
          <input type="text" className="form-control" name="acquire_home_addr_address2"
            value={hdd.acquire_home_addr_address2} onChange={this.updateField} 
            maxLength={255} />
        </div>

        <div className="row" style={{display: "flex"}}>
          <div className="col-sm-12">
            <div className="form-group">
              <label>City</label>
              <input type="text" className="form-control" name="acquire_home_addr_city"
                value={hdd.acquire_home_addr_city} onChange={this.updateField} 
                maxLength={255} required={!this.props.acquire_use_main_address} />
            </div>
          </div>

          <div className="col-sm-12">
            <div className="form-group">
              <label>State</label>
              <select className="form-control" name="acquire_home_addr_state" 
                value={hdd.acquire_home_addr_state}
                onChange={this.updateField} required={!this.props.acquire_use_main_address} >
                {[...usstates].map(ss => (
                <option key={ss[0]} value={ss[0]}>{ss[1]}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="form-group">
              <label>Zip</label>
              <input type="text" className="form-control" name="acquire_home_addr_zip"
                value={hdd.acquire_home_addr_zip} onChange={this.updateField} 
                maxLength={255} required={!this.props.acquire_use_main_address} />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>Phone</label>
          <input type="tel" className="form-control" name="acquire_home_addr_phone"
            value={hdd.acquire_home_addr_phone} onChange={this.updateField} 
            maxLength={255} required={!this.props.acquire_use_main_address}  />
        </div>
      </div>

      <div className="form-group">
        <label>Requested Pickup Time</label>
        <div>
          <DateTimePicker
            name="acquire_time"
            onChange={(d: Date) => this.update("acquire_time", d)}
            value={reqDate}
            disableClock={true}
            onCalendarOpen={() => { this.setState({ calendarOpen: 'acquire' }) }}
            onCalendarClose={() => { this.setState({ calendarOpen: ''}) }}
          />
        </div>
        <div className="form-help">
          PPMS staff will call to confirm pickup time
        </div>
      </div>

    </div>
    )
  }


  get showAcquireForm_dropoff() {

    const hdd = this.props;
    const reqDate = hdd.acquire_time ? new Date(hdd.acquire_time) : null;
    
    return (
      <div className="dohomedelivery">

      <h5><small>Drop-off Appointment at Precious Pets Facility</small></h5>
      <p>Schedule a time to drop-off at our facility.</p>
      
      <div className="alert alert-danger">
        <p>PPMS will call to confirm appointment time works, please do not show up to the appointment time without verbal or email confirmation as we might not be available at that time</p>
      </div>

      <div>
        <div className="form-group">
          <label>Requested Drop-off Time</label>
          <div>
            <DateTimePicker
              name="acquire_time"
              onChange={(d: Date) => this.update("acquire_time", d)}
              value={reqDate}
              disableClock={true}
              onCalendarOpen={() => { this.setState({ calendarOpen: 'acquire' }) }}
              onCalendarClose={() => { this.setState({ calendarOpen: ''}) }}  
            />
          </div>
          <div className="form-help">
            PPMS staff will call to confirm pickup time
          </div>
        </div>
      </div>

    </div>
    )
  }



  get showReleaseForm() {
    switch(this.props.release_type) {
      case "home":
        return this.showReleaseForm_home;
      case "pickup":
        return this.showReleaseForm_pickup;
    }
  }

  
  get showReleaseForm_home() {

    const hdd = this.props;
    const reqDate = hdd.release_time ? new Date(hdd.release_time) : null;
    const feePrice = new OrderDataItemPriceData(this.props.weight || 0, hdd.release_fees.find(f => f.type === 'home')?.pricing, this.props.service?.tag);

    return (
    <div className="dohomedelivery">

      <h5><small>Delivery</small></h5>
      <p>PPMS will deliver directly to your residence via USPS. (Allow a minimum of 10 days)</p>

      {feePrice && feePrice.total ? 
      <h5>
        Delivery Fee: {this.toMoney(feePrice.total)}
      </h5>
      : ''}

      <div className="my-3">
        <label>Signature Option</label>
        <select className="form-control" style={{'maxWidth': '400px'}}
          name="release_require_signature"
          onChange={this.updateField}
          required
          >
          <option value="">Select Option...</option>
          <option value="1">Require a Signature</option>
          <option value="0">Do NOT Require a Signature</option>
        </select>
      </div>


      <div className="checkbox" style={{ 
        display: hdd.release_type === "home" ? 'block' : 'none',
        }}>
        <label>
          <input type="checkbox" name="release_use_main_address" value={1} 
            defaultChecked={this.props.release_use_main_address} 
            onChange={() => this.update('release_use_main_address', !hdd.release_use_main_address)}
            />
          Use main address above
        </label>
      </div>

      <div style={{ 
        display: hdd.release_type === "home" && hdd.release_use_main_address ? 'none' : 'block',
        }}>

        <div className="form-group">
          <label>Name</label>
          <input type="text" className="form-control" name="release_home_addr_name"
            value={hdd.release_home_addr_name} onChange={this.updateField} 
            maxLength={255} required={!this.props.release_use_main_address} />
        </div>

        <div className="form-group">
          <label>Address Line1</label>
          <input type="text" className="form-control" name="release_home_addr_address1"
            value={hdd.release_home_addr_address1} onChange={this.updateField} 
            maxLength={255} required={!this.props.release_use_main_address} />
        </div>

        <div className="form-group">
          <label>Address Line2</label>
          <input type="text" className="form-control" name="release_home_addr_address2"
            value={hdd.release_home_addr_address2} onChange={this.updateField} 
            maxLength={255} />
        </div>

        <div className="row" style={{display: "flex"}}>
          <div className="col-sm-12">
            <div className="form-group">
              <label>City</label>
              <input type="text" className="form-control" name="release_home_addr_city"
                value={hdd.release_home_addr_city} onChange={this.updateField} 
                maxLength={255} required={!this.props.release_use_main_address} />
            </div>
          </div>

          <div className="col-sm-12">
            <div className="form-group">
              <label>State</label>
              <select className="form-control" name="release_home_addr_state" 
                value={hdd.release_home_addr_state}
                onChange={this.updateField} required={!this.props.release_use_main_address} >
                {[...usstates].map(ss => (
                <option key={ss[0]} value={ss[0]}>{ss[1]}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="form-group">
              <label>Zip</label>
              <input type="text" className="form-control" name="release_home_addr_zip"
                value={hdd.release_home_addr_zip} onChange={this.updateField} 
                maxLength={255} required={!this.props.release_use_main_address} />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>Phone</label>
          <input type="tel" className="form-control" name="release_home_addr_phone"
            value={hdd.release_home_addr_phone} onChange={this.updateField} 
            maxLength={255} required={!this.props.release_use_main_address}  />
        </div>
      </div>

      <div className="form-group">
        <label>Requested Delivery Time</label>
        <div>
          <DateTimePicker
            name="release_time"
            onChange={(d: Date) => this.update("release_time", d)}
            value={reqDate}
            disableClock={true}
            onCalendarOpen={() => { this.setState({ calendarOpen: 'release' }) }}
            onCalendarClose={() => { this.setState({ calendarOpen: ''}) }}
          />
        </div>

      </div>
    </div>
    )
  }


  get showReleaseForm_pickup() {

    const hdd = this.props;
    const reqDate = hdd.release_time ? new Date(hdd.release_time) : null;
    
    return (
      <div className="dohomedelivery">

      <h5><small>Pick-up Appointment at Precious Pets Facility</small></h5>
      <p>Schedule a time to pick-up at our facility. (Allow minimum of 8 days)</p>
      
      <div className="alert alert-danger">
        <p>PPMS will call to confirm appointment time works, please do not show up to the appointment time without verbal or email confirmation as we might not be available at that time</p>
      </div>

      <div>
        <div className="form-group">
          <label>Requested Pickup Time</label>
          <div>
            <DateTimePicker
              name="release_time"
              onChange={(d: Date) => this.update("release_time", d)}
              value={reqDate}
              disableClock={true}
              onCalendarOpen={() => { this.setState({ calendarOpen: 'release' }) }}
              onCalendarClose={() => { this.setState({ calendarOpen: ''}) }}  
            />
          </div>
          <div className="form-help">
            PPMS staff will call to confirm pickup time
          </div>
        </div>
      </div>

    </div>
    )
  }


  showPricing(stype:ConfType) {
    return this.showPrice(stype.pricing);
  }


  showPrice(pconf:ConfPricing) {

    if (this.props.weight === "") return;

    const effective_weight = effectiveWeight(this.props.weight);

    if (pconf.pricetype === 'fixed' && pconf.price) {
      return (
        <div className="price fixed">
          <span className="p"><span>Price:</span> {this.toMoney(pconf.price)}</span>
        </div>
      )

    } else if (pconf.pricetype === 'fixed_additional' && pconf.price) {
      return (
        <div className="price fixed">
          <span className="p"><span>Price:</span> 
            {this.toMoney(pconf.price)} 
            {pconf.price_additional ? 
              <>
                {" "}<span>for one,</span>{" "}
                <span>+{this.toMoney(pconf.price_additional)} for each additional)</span> 
              </>
              : '' }
          </span>
          
        </div>
      )

    } else if (pconf.pricetype === 'byweight' && pconf.price) {

      return (
        <div className="price byweight">
          <span className="per">({this.toMoney(pconf.price)} / lb x {effective_weight}lbs)</span>
          {" "}
          <span className="p"><span>Price:</span> {this.toMoney(pconf.price * effective_weight)}</span>
        </div>
      )

    } else if (pconf.pricetype === 'tiered' && pconf.prices) {

      let rangeBottom = 1;
      let rangeTop = 0;
      let myprice:ConfTierPrice | undefined;

      // match the price tier with the weight
      for (let i = 0; i < pconf.prices.length; i++) {
        let pt = pconf.prices[i];
        rangeTop = (pt.max && pt.max > 0) ? pt.max : 0;
        if (!pt.max || effective_weight <= pt.max) {
          myprice = pt;

          let n = pconf.prices[i - 1];
          rangeBottom = (n && n.max && n.max > 0) ? (n.max + 1) : 0;
  
          break;
        }
      }

      if (!myprice) return "";

      let rangeStr = '';
      if (rangeTop && rangeBottom) {
        rangeStr = `${rangeBottom}-${rangeTop}lbs`;
      } else if (rangeTop && !rangeBottom) {
        rangeStr = `up to ${rangeTop}lbs`;
      } else if (rangeBottom && !rangeTop) {
        rangeStr = `${rangeBottom}+lbs`;
      }

      return (
        <div className="price tier">
          <span className="range">({rangeStr})</span>
          {" "}
          <span className="p"><span>Price:</span> {this.toMoney(myprice.price)}</span>
        </div>
      )

    } else if (pconf.pricetype === 'service_tiered' && pconf.sprices) {
      
      // match the price with the selected service
      const service = this.props.service?.tag;
      let price = pconf.sprices[""] || 0;
      if (service) {
        price = pconf.sprices[service];
      }

      return (
        <div className="price service_tiered">
          <span className="p"><span>Price:</span> {this.toMoney(price)}</span>
        </div>
      )
    }

    return "";
  }


  toMoney(cents:number) {
    let d = Math.floor(cents / 100)+"";
    let c = (Math.floor(cents % 100)+"").padStart(2, '0');
    return "$" + d + "." + c;
  }


  updateField = (e:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    return this.props.updateField(e);
  }


  updateFieldWeight = (e:React.ChangeEvent<HTMLInputElement>) => {
    const f_lbs = (document.getElementById('OrderFormWeightLbs') as HTMLInputElement);
    const f_oz = (document.getElementById('OrderFormWeightOz') as HTMLInputElement);

    let lbs = parseInt(f_lbs.value);
    let oz = parseInt(f_oz.value);
    lbs = lbs > 0 ? lbs : 0;
    oz = oz > 0 ? oz : 0;

    oz = oz + (lbs * 16);

    return this.props.update('weight', oz);
  }


  update = (field: string, val: any) => {
    if (field === 'service') {
      // remove private options if we've selected something besides private
      if (val.tag !== 'private') {
        this.update('extras_urn', undefined);
        this.update('extras_nameplate', undefined);
      }
    }

    this.props.update(field, val)
  }


  clearOption = (e:React.MouseEvent, opttag:string) => {
    e.preventDefault();
    e.stopPropagation();

    return this.props.update(opttag, '');
  }


  checkForm = (e:React.FormEvent) => {
    e.preventDefault();

    (e.target as HTMLFormElement).checkValidity();
    let valid = (e.target as HTMLFormElement).checkValidity();

    if (!(this.props.weight && this.props.weight > 0)) {
      this.setState({
        formError: "weight"
      })
      valid = false;
    }

    if (!this.props.service) {
      this.setState({
        formError: "service"
      })
      valid = false;
    }

    if (valid) {

      /* TODO
      if (this.props.home_pickup && this.props.home_delivery && this.props.home_delivery_use_pickup_address) {
        const reqtime = this.props.home_delivery_detail?.requested_time;
        this.update('home_delivery_detail', {
          ...this.props.home_pickup_detail,
          requested_time: reqtime,
        })
      }
      */

      // check the acquire option
      if (this.props.service?.tag && ['noservice'].includes(this.props.service.tag)) {
        // these services get no acquire type
        this.update('acquire_type', "");

        // clear any additional info from the acquire info
        [
          "acquire_home_addr_name",
          "acquire_home_addr_address1",
          "acquire_home_addr_address2",
          "acquire_home_addr_city",
          "acquire_home_addr_state",
          "acquire_home_addr_zip",
          "acquire_home_addr_phone",
          "acquire_time",
          "acquire_use_main_address"
        ].forEach(f => this.props.update(f, ""));

      }


      // check the home delivery option
      if (this.props.service?.tag && ['burial', 'communal'].includes(this.props.service.tag) && !this.props.extras_pawprint) {
        // these services get no release type
        this.update('release_type', "");

        // clear any additional info from the release info
        [
          "release_home_addr_name",
          "release_home_addr_address1",
          "release_home_addr_address2",
          "release_home_addr_city",
          "release_home_addr_state",
          "release_home_addr_zip",
          "release_home_addr_phone",
          "release_time",
          "release_use_main_address"
        ].forEach(f => this.props.update(f, ""));
      }

      this.update('reviewing', true);
      return true;
    }

    return false;
  }


  areaExpand = (ref: React.RefObject<HTMLElement>) => {
    const el = ref.current;
    if (!el) return;

    if (el.classList.contains('active')) {
      return;
    }

    const l = (e: Event) => {
      el.style.height = '';
      el.removeEventListener('transitionend', l);
    }
    el.addEventListener('transitionend', l);

    const ch = el.children[0];
    const h = ch.getBoundingClientRect().height;
    el.style.height = h+'px';
    el.classList.add('active');
  }


  areaContract = (ref: React.RefObject<HTMLElement>) => {
    const el = ref.current;
    if (!el) return;

    if (!el.classList.contains('active')) {
      return;
    }

    const ch = el.children[0];
    const h = ch.getBoundingClientRect().height;
    el.style.height = h+'px';
    let x = el.offsetHeight;

    el.classList.remove('active');
    el.style.height = '0';
  }

}


export default OrderForm;
